import { esc, cohortIcons, formatDateTime, displayName } from "./utils.js";
import { navigate } from "./app.js";

/**
 * Renders a dive plan as a clickable card. Used everywhere dive plans are
 * listed (the Dive Plans tab, a dive site's detail page, a community's
 * detail page) so the community tag renders consistently everywhere,
 * mirroring the Flutter app's single shared DivePlanCard widget.
 */
export function planCardHtml(plan) {
  const badge = plan.is_past
    ? `<span class="badge text-bg-secondary">Past</span>`
    : `<span class="badge text-bg-primary">Upcoming</span>`;
  const joined = plan.max_participants
    ? `${plan.participant_count}/${plan.max_participants} joined`
    : `${plan.participant_count} joined`;
  return `
    <div class="card mb-3 card-dc-clickable" data-plan-id="${plan.id}">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-start mb-2">
          <h3 class="h6 fw-semibold mb-0">${esc(plan.title)}</h3>
          ${badge}
        </div>
        <!-- An event with no site has not lost one: the organizer has
             not settled it yet. Saying so beats a blank line, which
             reads as missing data. -->
        <div class="text-slate small mb-1"><i class="bi bi-geo-alt me-1"></i>${
          plan.dive_site ? esc(plan.dive_site.name) : "Site to be determined"
        }</div>
        ${plan.community ? `<span class="badge text-bg-light border mb-1 community-chip" data-community-id="${plan.community.id}">${cohortIcons(plan.community)}${esc(plan.community.name)}</span>` : ""}
        <div class="text-slate small mb-1"><i class="bi bi-clock me-1"></i>${formatDateTime(plan.planned_date)}</div>
        <div class="d-flex justify-content-between text-slate small mt-2">
          <span><i class="bi bi-people me-1"></i>${joined}</span>
          ${plan.organizer ? `<span>by ${esc(displayName(plan.organizer))}</span>` : ""}
        </div>
      </div>
    </div>`;
}

/** Wires up click handlers on a container of planCardHtml() cards: the
 * card itself opens the plan, the community chip opens that community
 * (stopPropagation so it doesn't also trigger the card's own click). */
export function attachPlanCardHandlers(container) {
  container.querySelectorAll("[data-plan-id]").forEach((card) => {
    card.addEventListener("click", (e) => {
      if (e.target.closest(".community-chip")) return;
      navigate(`/dive-plan/${card.dataset.planId}`);
    });
  });
  container.querySelectorAll(".community-chip").forEach((el) => {
    el.addEventListener("click", (e) => {
      e.stopPropagation();
      navigate(`/cohort/${el.dataset.communityId}`);
    });
  });
}
